import axios from "axios"
import qs from 'qs' //按需引入
const install = (Vue,vm) => {

  function get (url,params){
    return new Promise((resolve,reject) => {
      axios.get(url,{params}).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }

  function post (url,params,headers){
    // 某些请求不用JSON格式 就需要判断
    let _params = params
    if(headers === undefined){
      axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
      _params = qs.stringify(params);
    }else{
      axios.defaults.headers['Content-Type'] = 'application/json; charset=UTF-8';
    }
    return new Promise((resolve, reject) => {
      axios.post(url, params,headers,{indices: false}).then((res) => {
          resolve(res);// 返回请求成功的数据 data
      }).catch((err) => {
          reject(err);//返回失败的错误信息
      });
    });
  }
  let api = {
    get,post,
    //登录
    login: (data) => post('/oauth/token', data),
    // 注册
    register: (data) => post('/register', data,true),
    // 查询文件列表
    fileList:(params) => get('/fileManage/list',params),
    //获取用户中心投标记录
    userFileManageList:() => get('/userFileManage/list'),
    //获取用户信息
    userInfo:() => get('/memberManage/info'),
    //修改密码
    updatePassword:(data) => post('/memberManage/updatePassword',data),
    //修改用户信息
    memberManageUpdate:(data) => post('/memberManage/update',data,true),
    //文件内容详情
    fileDetail:(params) => get('/fileManage/info',params),
    //提交申请
    submitCaigou:(data) => post('/userFileManage/add',data),
    //轮播图
    imageList:() => get('/image/list'),
    //搜索项目名称
    searchFor: (params) => get('/fileManage/searchFor',params),
    // 获取验证码
    getCodeImg: (params) => get('/captchaImage',params),
  }
  Vue.prototype.$api = api  //挂载到vue 原型 在页面中调用就用this.$api.gate_login({xxx:xxx}).then(res => {console.log(res)})
}

export default {
  install
}